import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useFlattenDataAndUIConfig } from 'hooks/useFlattenDataAndUIConfig';
import { applyRowMasksToData } from 'services/datachecks/datachecks';
import { setIsBigMessage, setIsLoading, setUiConfig, useWebEDIStore } from 'stores/webedi/webedi';
import { isBigMessage } from 'support/helpers/messages/messages';

export const useInitialWebEDISetup = () => {
  // Initial canonical is initialized when loading the process specification
  // and is used to set the initial form data and UI config.
  const initialCanonical = useWebEDIStore((state) => state.initialCanonical);

  const processSpecificationFields = useWebEDIStore((state) => state.processSpecificationFields);
  const { reset } = useFormContext();
  const { data, uiConfig, isLoading } = useFlattenDataAndUIConfig(processSpecificationFields, initialCanonical);

  useEffect(() => {
    if (uiConfig) {
      setUiConfig(uiConfig);
    }

    if (data) {
      const filteredData = uiConfig ? applyRowMasksToData(data, uiConfig) : data;
      setIsBigMessage(isBigMessage(data ?? undefined));
      reset(filteredData);
    }
  }, [data, reset, uiConfig]);

  useEffect(() => {
    setIsLoading(isLoading);
  }, [isLoading]);
};
